import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import StructuredData from '../../components/feature/StructuredData';

const FaqPage = () => {
  useEffect(() => {
    document.title = 'Preguntas Frecuentes - Vaciado de Locales Barcelona | ECOSERVEIS';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Resuelve tus dudas sobre vaciado de locales Barcelona: plazos, precios, permisos, desmontajes. Respuestas a preguntas frecuentes sobre nuestros servicios. ☎ 644 613 451');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Resuelve tus dudas sobre vaciado de locales Barcelona: plazos, precios, permisos, desmontajes. Respuestas a preguntas frecuentes sobre nuestros servicios. ☎ 644 613 451';
      document.head.appendChild(meta);
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'preguntas vaciado locales, FAQ vaciado Barcelona, dudas retirada mobiliario, precios vaciado naves, plazos vaciado oficinas');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'preguntas vaciado locales, FAQ vaciado Barcelona, dudas retirada mobiliario, precios vaciado naves, plazos vaciado oficinas';
      document.head.appendChild(meta);
    }
  }, []);

  const faqs = [
    {
      question: '¿En cuánto tiempo pueden realizar el vaciado?',
      answer: 'Según disponibilidad, podemos realizar el servicio en 24-48 horas. El tiempo exacto depende del volumen a retirar y la complejidad del trabajo. Para vaciados urgentes, contacta directamente por teléfono y verificaremos disponibilidad inmediata. En casos de grandes volúmenes o trabajos complejos, el plazo puede extenderse, pero siempre te informaremos con antelación del tiempo estimado.'
    },
    {
      question: '¿Cómo se calcula el precio del servicio?',
      answer: 'El precio depende de varios factores: volumen de material a retirar, tipo de enseres (mobiliario ligero o pesado), accesibilidad del local (planta, ascensor, ancho de puertas), necesidad de desmontajes especiales, y si requiere limpieza final. Ofrecemos presupuestos sin compromiso tras una visita presencial o valoración fotográfica detallada. Nuestros precios son transparentes y sin sorpresas.'
    },
    {
      question: '¿Qué tipos de inmuebles vacían?',
      answer: 'Vaciamos locales comerciales (tiendas, bares, restaurantes), naves industriales y almacenes, oficinas y despachos, trasteros, garajes, y cualquier espacio comercial o industrial. No realizamos vaciados de viviendas particulares. Nuestro servicio está especializado en espacios comerciales e industriales de todo tipo y tamaño.'
    },
    {
      question: '¿Necesito permisos especiales para el vaciado?',
      answer: 'En la mayoría de casos no son necesarios permisos especiales para el vaciado interior. Si se requiere ocupación de vía pública con contenedores o vehículos durante tiempo prolongado, nosotros gestionamos los permisos necesarios con el ayuntamiento correspondiente. Este trámite está incluido en nuestro servicio cuando es necesario. Te informaremos si tu caso requiere permisos adicionales.'
    },
    {
      question: '¿Qué pasa si el local tiene difícil acceso?',
      answer: 'Trabajamos habitualmente en locales con todo tipo de accesos: sótanos, plantas altas sin ascensor, calles estrechas del casco antiguo, locales con puertas pequeñas, etc. Evaluamos cada caso durante la visita previa y adaptamos nuestro equipo y método de trabajo a las condiciones específicas. Contamos con experiencia en accesos complicados en toda Barcelona y provincia.'
    },
    {
      question: '¿En qué horario trabajan?',
      answer: 'Nos adaptamos a tus necesidades y las normativas de la comunidad de vecinos. Podemos trabajar en horario comercial estándar, fines de semana, o en horarios especiales según disponibilidad y coordinación previa. Si tu comunidad tiene restricciones de horario para trabajos, nos ajustamos a ellas. Consúltanos tu caso particular y encontraremos la mejor solución.'
    },
    {
      question: '¿Realizan desmontajes de mobiliario fijo?',
      answer: 'Sí, realizamos desmontajes no estructurales como estanterías metálicas y de madera, mostradores, barras, mamparas de oficina, falsos techos accesibles, y elementos de carpintería no estructural. No realizamos obras ni desmontajes que afecten a la estructura del edificio, instalaciones eléctricas principales o fontanería. Si tienes dudas sobre un desmontaje específico, consúltanos.'
    },
    {
      question: '¿Cómo gestionan los residuos?',
      answer: 'Gestionamos todos los residuos de forma legal y responsable cumpliendo la normativa ambiental vigente. Separamos materiales reciclables (metal, madera, plástico, cartón), llevamos enseres reutilizables a puntos de donación cuando es posible, y depositamos el resto en plantas de tratamiento autorizadas. Podemos entregar certificados de gestión de residuos si los necesitas para trámites administrativos.'
    },
    {
      question: '¿Tienen seguro de responsabilidad civil?',
      answer: 'Sí, todos nuestros servicios están cubiertos por un seguro de responsabilidad civil. Incluimos el número de póliza en todos nuestros presupuestos por escrito. Esto te protege ante cualquier incidencia durante el servicio. Es importante que exijas este dato a cualquier empresa de vaciados para evitar sorpresas desagradables.'
    },
    {
      question: '¿Entregan factura del servicio?',
      answer: 'Sí, emitimos factura completa de todos nuestros servicios. Somos una empresa legalmente constituida y cumplimos con todas las obligaciones fiscales. La factura incluye el detalle del servicio realizado, gestión de residuos, y cualquier trabajo adicional acordado. Puedes deducir el gasto si es para actividad empresarial o profesional.'
    },
    {
      question: '¿Recogen un solo objeto o mueble suelto?',
      answer: 'No, nuestro servicio mínimo es el equivalente a una furgoneta llena. Estamos especializados en vaciados completos de locales, naves y oficinas, no en recogida de objetos individuales. Este servicio mínimo nos permite mantener precios competitivos en vaciados completos. Si necesitas retirar solo algunos objetos, te recomendamos contactar con servicios de recogida de muebles específicos.'
    },
    {
      question: '¿Ofrecen servicio de limpieza final?',
      answer: 'Sí, ofrecemos limpieza final opcional tras el vaciado. Este servicio incluye barrido, fregado de suelos, limpieza de polvo y residuos, limpieza de cristales, y retirada de adhesivos y marcas. Dejamos el espacio completamente limpio y listo para entrega de llaves, reforma o nuevo uso. Consúltanos para incluir la limpieza en tu presupuesto personalizado.'
    }
  ];

  return (
    <>
      <StructuredData type="faq" />
      <Header />
      <WhatsAppButton />
      
      <main>
        {/* Hero Section */}
        <section className="pt-32 pb-20 lg:pt-36 lg:pb-20 bg-gradient-to-br from-gray-50 to-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="inline-flex items-center px-4 py-2 bg-white border border-gray-200 rounded-full mb-6">
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-question-line text-[#FF6B35]"></i>
              </div>
              <span className="text-sm font-medium text-gray-700">Preguntas Frecuentes</span>
            </div>
            
            <h1 className="font-['Sora'] text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
              Preguntas frecuentes
            </h1>
            
            <p className="text-xl text-gray-600 leading-relaxed mb-8">
              Respuestas a las preguntas más frecuentes sobre nuestros servicios de <strong>vaciado de locales Barcelona</strong>, <strong>vaciado de naves industriales</strong> y <strong>vaciado de oficinas</strong>. <Link to="/servicios" className="text-[#FF6B35] hover:underline font-semibold">Ver todos nuestros servicios</Link>.
            </p>
          </div>
        </section>

        {/* FAQ Accordion */}
        <section className="py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <details
                  key={index}
                  className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow"
                >
                  <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50 transition-colors">
                    <h4 className="text-lg font-bold text-gray-900 pr-4">
                      {faq.question}
                    </h4>
                    <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-[#FF6B35]/10 rounded-full">
                      <i className="ri-add-line text-xl text-[#FF6B35] group-open:hidden"></i>
                      <i className="ri-subtract-line text-xl text-[#FF6B35] hidden group-open:block"></i>
                    </div>
                  </summary>
                  <div className="px-6 pb-6">
                    <p className="text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Información Adicional */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12">
              <h2 className="font-['Sora'] text-3xl font-bold text-gray-900 mb-6 text-center">
                ¿Tienes Más Preguntas?
              </h2>
              <p className="text-lg text-gray-600 text-center mb-8 leading-relaxed">
                Si no encuentras la respuesta que buscas sobre nuestros servicios de <strong>retirada de mobiliario comercial</strong>, <strong>desmontaje de estanterías</strong> o cualquier otro aspecto, no dudes en contactarnos directamente. <Link to="/empresa" className="text-[#FF6B35] hover:underline">Conoce más sobre nuestra empresa</Link>.
              </p>
              
              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="flex items-start p-6 bg-gray-50 rounded-xl">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-phone-line text-2xl text-[#FF6B35]"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2">Llámanos</h3>
                    <a
                      href="tel:+34644613451"
                      className="text-[#FF6B35] font-semibold hover:text-[#E55A2B] transition-colors cursor-pointer"
                    >
                      +34 644 613 451
                    </a>
                    <p className="text-sm text-gray-600 mt-1">
                      Atención personalizada
                    </p>
                  </div>
                </div>

                <div className="flex items-start p-6 bg-gray-50 rounded-xl">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-whatsapp-line text-2xl text-[#FF6B35]"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2">WhatsApp</h3>
                    <a
                      href="https://wa.me/34644613451"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#FF6B35] font-semibold hover:text-[#E55A2B] transition-colors cursor-pointer"
                    >
                      Enviar mensaje
                    </a>
                    <p className="text-sm text-gray-600 mt-1">
                      Respuesta rápida
                    </p>
                  </div>
                </div>
              </div>

              <div className="text-center">
                <p className="text-gray-600 mb-4">
                  También puedes solicitar un presupuesto sin compromiso o <Link to="/servicios" className="text-[#FF6B35] hover:underline">consultar todos nuestros servicios</Link>
                </p>
                <Link
                  to="/contacto"
                  className="inline-flex items-center text-[#FF6B35] font-semibold hover:text-[#E55A2B] transition-colors cursor-pointer"
                >
                  Ir a la página de contacto
                  <div className="w-5 h-5 flex items-center justify-center ml-2">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-20 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="font-['Sora'] text-4xl font-bold mb-6">
              ¿Listo para Solicitar tu Presupuesto?
            </h2>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              Servicio urgente en 24-48h según disponibilidad. Presupuesto sin compromiso para <strong>fin de alquiler</strong>, <strong>cierre</strong>, <strong>traspaso</strong> o <strong>reforma</strong>. <Link to="/" className="text-white hover:text-gray-200 underline">Volver al inicio</Link>.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:+34644613451"
                className="inline-flex items-center justify-center px-8 py-4 bg-[#FF6B35] text-white text-lg font-semibold rounded-lg hover:bg-[#E55A2B] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-phone-fill"></i>
                </div>
                Llamar Ahora
              </a>
              <a
                href="https://wa.me/34644613451"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-8 py-4 bg-white text-gray-900 text-lg font-semibold rounded-lg hover:bg-gray-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-whatsapp-line"></i>
                </div>
                WhatsApp
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default FaqPage;